import { Injectable } from '@angular/core';
import {OrderService} from '../order-service';
import {SpinnerOverlayService} from '../../Components/spinner/spinner-overlay.service';

@Injectable({
  providedIn: 'root'
})
export class OrderUtilsService {


  constructor(private orderService: OrderService, private spinner: SpinnerOverlayService) {
  }

  downloadOrderExcel(orderNumber: string) {
    this.handleLoading(true);
    this.orderService.downloadOrderExcel(orderNumber).subscribe({
      next: (response: any) => {
        const base64String = response.file;
        const fileName = response.fileName;
        const contentType = response.contentType;

        const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
          const byteCharacters = atob(b64Data); // Decodifica Base64
          const byteArrays = [];

          for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
          }

          return new Blob(byteArrays, { type: contentType });
        };

        const blob = b64toBlob(base64String, contentType);
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();

        URL.revokeObjectURL(url);
        this.handleLoading(false);
      },
      error: () => {
        this.handleLoading(false);
      }
    });
  }

  handleLoading(loading: boolean) {
    if (loading) this.spinner.show(); else this.spinner.hide()
  }

}
